/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Create_LeadInputs */

const cs_messages_create_lead = /** @type {(inputs: Messages_Create_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit lead`)
};

const en_messages_create_lead = /** @type {(inputs: Messages_Create_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create lead`)
};

/**
* | output |
* | --- |
* | "Create lead" |
*
* @param {Messages_Create_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_create_lead = /** @type {((inputs?: Messages_Create_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Create_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_create_lead(inputs)
	return cs_messages_create_lead(inputs)
});